export default __webpack_public_path__ + "static/media/Relatorios (Real Size).93093b62.svg";